<script setup lang="ts"></script>

<template>
  <v-container fluid class="background-chalkboard">
    <slot></slot>
  </v-container>
</template>

<style scoped lang="scss">
.background-chalkboard {
  background-image: url('../assets/chalkboard.webp');
  background-size: cover;
  background-position: center;
  min-height: calc(100vh - 64px);
}
</style>
